<!-- index.vue -->

<template>
  <div class="page"></div>
</template>
<script>
// 引入stompjs

import Stomp from 'stompjs'
export default {
  data() {
    return {
      MQTT_SERVICE: 'ws://127.0.0.1:15674/ws', // mqtt服务地址
      MQTT_USERNAME: 'guest', // 连接用户名
      MQTT_PASSWORD: 'guest', //  连接密码
    }
  },

  mounted() {
    this.setRabitMQ()
  },

  methods: {
    // 初始化
    setRabitMQ() {
      this.client = Stomp.client(this.MQTT_SERVICE)
      this.connect()
    },

    onConnected: function (frame) {
      //订阅频道
      this.client.subscribe(
        // 订阅到交换机
        '/exchange/epai.xihan.ui',
        this.responseCallback // this.onFailed
      )
    }, // 失败后的处理

    onFailed: function (frame) {
      console.log('MQ Failed: ' + frame) // 失败后  等待5秒后重新连接
      setTimeout(() => {
        this.getRabitMQ()
      }, 5000)
    }, // 回传消息 MQ连接成功后的 数据相应 接收消息处理

    responseCallback: function (frame) {
      console.log(frame.body)

      this.$message({
        message: frame.body,
        type: 'error',
      })
      // try {
      //   // 格式化MQ消息
      //   let data = JSON.parse(JSON.parse(frame.body)) // 将mq信息放到vuex中 // this.$store.dispatch("setMQCutterDataList", data);
      // } catch (e) {
      //   console.log(e)
      // }
    }, // 开始连接

    connect: function () {
      const headers = {
        // 賬號
        login: this.MQTT_USERNAME, // 密碼
        passcode: this.MQTT_PASSWORD,
      } //   登录Rabbit MQ服务

      this.client.connect(headers, this.onConnected, this.onFailed)
    },
  },
}
</script>

<style scoped></style>
